import { SVGProps, Ref, forwardRef } from 'react';

export const FolderArrowRightOutlinedSize24Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M20.517 8.642c-.18-.949-.48-1.496-.821-1.838-.56-.56-1.67-1.004-4.196-1.004h-4.419l-.8-2H8.5c-2.525 0-3.636.444-4.196 1.004-.535.535-.964 1.573-1.001 3.867.68-.117 1.475-.171 2.391-.171h12.612q1.253-.002 2.211.142M1.5 9v.278c-1.558.923-1.83 2.748-1.148 5.886C1.439 20.163 3.307 22 8.4 22H13v-1.8H8.4c-2.37 0-3.583-.435-4.342-1.098-.79-.692-1.426-1.923-1.947-4.32-.541-2.488-.265-3.37-.001-3.698.26-.326 1.05-.784 3.584-.784h12.612c2.533 0 3.323.458 3.584.784.158.197.321.593.31 1.416H24c.017-1.607-.474-2.652-1.581-3.269C22.02 5.35 20.109 4 15.5 4h-3.2l-.8-2h-3c-5.25 0-7 1.75-7 7M24 18l-4.011 4-1.273-1.27 1.838-1.833H14v-1.794h6.554l-1.838-1.834L19.989 14z"
                    fill="currentColor"
                />
            </g>
        </svg>
    )
);
FolderArrowRightOutlinedSize24Glyph.displayName = 'FolderArrowRightOutlinedSize24Glyph';
